import Footer from './components/Footer.tsx';
import Header from './components/Header.tsx';
import PlayerCard from './components/PlayerCard.tsx';
import RulesPanel from './components/RulesPanel.tsx';
import SquadPoster from './components/SquadPoster.tsx';
import SquadTable from './components/SquadTable.tsx';
import TacticsPanel from './components/TacticsPanel.tsx';
import TransferModal from './components/TransferModal.tsx';
import { useSquad } from './lib/squadContext.ts';
import { C } from './lib/theme.ts';

/** Width of the side panels when open, and of the collapsed rail when shut. */
const RULES_PANEL_WIDTH = '330px';
const PLAYER_PANEL_WIDTH = '380px';
const COLLAPSED_RAIL = '40px';

export default function App() {
  const { state } = useSquad();

  // The centre column takes back whatever a collapsed side panel gives up.
  const gridTemplateColumns = [
    state.rulesPanelOpen ? RULES_PANEL_WIDTH : COLLAPSED_RAIL,
    'minmax(0, 1fr)',
    state.playerPanelOpen ? PLAYER_PANEL_WIDTH : COLLAPSED_RAIL,
  ].join(' ');

  return (
    <div style={{ minWidth: 1500, background: C.bg, paddingBottom: 60 }}>
      <Header />

      <div style={{ display: 'grid', gridTemplateColumns, gap: 0, alignItems: 'start' }}>
        <RulesPanel />
        <SquadTable />
        <PlayerCard />
        <TransferModal />
        <TacticsPanel />
      </div>

      <SquadPoster />
      <Footer />
    </div>
  );
}
